import { render, staticRenderFns } from "./RecipeListCard.vue?vue&type=template&id=a75d4a88&"
import script from "./RecipeListCard.vue?vue&type=script&lang=js&"
export * from "./RecipeListCard.vue?vue&type=script&lang=js&"
import style0 from "./RecipeListCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports